module.exports = __webpack_public_path__ + "static/media/claudecode.62daa73b.svg";